module.exports = __webpack_public_path__ + "static/media/4.035f26a4.jpeg";